"use strict";import{html as t}from"@cisco-u/base";export function facebookIcon({height:r=16,width:l=16,hidden:o=!1,title:e="Facebook",type:i="",hover:a=!1}={}){return i==="dark"?t`<svg
      width=${l}
      height=${r}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="${o?"true":"false"}"
      aria-label="${e}"
      role="img"
      style=${a?"color: var(--color-blue-primary);":"color: var(--color-white);"}
    >
      <circle cx="16" cy="16" r="16" fill="currentColor" />
      <path
        d="M19.5558 11.2592H17.9558C17.3182 11.2592 17.1854 11.5211 17.1854 12.1812V13.6295H19.5558L19.3081 15.9999H17.1854V24.2962H13.6299V15.9999H11.2595V13.6295H13.6299V10.8941C13.6299 8.79754 14.7333 7.70361 17.2198 7.70361H19.5558V11.2592Z"
        fill="#1B1C1D"
      />
    </svg>`:t`<svg
    width=${l}
    height=${r}
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${o?"true":"false"}"
    aria-label="${e}"
    role="img"
    style=${a?"color: var(--color-blue-primary);":"color: var(--color-gray-100);"}
  >
    <circle cx="16" cy="16" r="16" fill="currentColor" />
    <path
      d="M19.5558 11.2592H17.9558C17.3182 11.2592 17.1854 11.5211 17.1854 12.1812V13.6295H19.5558L19.3081 15.9999H17.1854V24.2962H13.6299V15.9999H11.2595V13.6295H13.6299V10.8941C13.6299 8.79754 14.7333 7.70361 17.2198 7.70361H19.5558V11.2592Z"
      fill="#F7F5F4"
    />
  </svg>`}
//# sourceMappingURL=facebook.js.map
